import React, { useEffect, useState, useGlobal } from 'reactn';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  message,
  Typography,
  Image,
  Radio,
  Checkbox,
  DatePicker,
} from 'antd';
import { useHistory } from 'react-router-dom';
import {
  LeftOutlined,
  CopyOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import api from '../service/index';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';

const SurveysWithMedia2AnswersDetail = (props) => {
  const { Paragraph } = Typography;
  let params = useParams();
  let history = useHistory();
  let id = params.id !== 'add' ? params.id : false;
  let surveyId = params.surveyId !== 'add' ? params.surveyId : false;
  let newRecord = {};
  let [data, setData] = useState(id ? {} : newRecord);
  let [, setErrors] = useState([]);
  let [loading, setLoading] = useState(id ? true : false);
  let [validationCheck, setValidationCheck] = useState(false);

  let [modules] = useGlobal('modules');
  let [pdfIcon] = useGlobal('pdfIcon');
  let [languagesCms] = useGlobal('languagesCms');
  let path = props.location.pathname.split('/')[1];
  let module;
  if (modules !== null) {
    [module] = modules.filter((el) => el._id === path);
  }

  const [, setIsLoading] = useState(true);

  const handleMessage = (event) => {
    if (event.data.action === 'receipt-loaded') {
      setIsLoading(false);
    }
  };

  const printIframe = (id) => {
    const iframe = document.getElementById(id);
    const iframeWindow = iframe.contentWindow;

    iframe.focus();
    iframeWindow.print();

    return false;
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    if (modules && id) {
      setLoading(true);
      api
        .get('/rest/surveyWithMedia2Answers/' + id)
        .then(({ data: { result, result_message } }) => {
          setData(result);
          setLoading(false);
        });
    }
  }, [id]);

  let validate = useCallback(() => {
    let errors = {};
    return errors;
  }, [data]);

  useEffect(() => {
    if (validationCheck) setErrors(validate());
  }, [validationCheck, data, validate]);

  let save = async () => {
    setValidationCheck(true);
    let err = validate();
    if (err.hasError) {
      setErrors(err);
      window.scrollTo({ top: 20, behavior: 'smooth' });
    } else {
      if (id) {
        api
          .put('/rest/surveysWithMedia2/' + id, data)
          .then(({ data: { result, result_message } }) => {
            if (result_message.type === 'success') {
              message.success(languagesCms.SUCCESS_EDIT_RECORD, 2);
              history.push('/surveysWithMedia2');
            } else message.error(languagesCms.ERROR_SAVE_RECORD, 2);
          });
      } else {
        api
          .post('/rest/surveysWithMedia2', data)
          .then(({ data: { result, result_message } }) => {
            if (result_message.type === 'success') {
              message.success(languagesCms.SUCCESS_SAVE_RECORD, 2);
              history.push('/surveysWithMedia2');
            } else {
              message.error(result_message.message, 2);
            }
          });
      }
    }
  };

  useEffect(() => {}, [data.questions]);

  return (
    <div>
      <div className="list-head">
        <div className="list-title">
          <h1>{module ? module.name : ''}</h1>
        </div>
        <div className="list-buttons">
          <Button
            type="light"
            icon={<CopyOutlined />}
            size="large"
            onClick={() => printIframe('print')}
            style={{ marginRight: '5px' }}
          >
            {languagesCms.PRINT}
          </Button>
          <Link to={'/surveysWithMedia2/answers/' + surveyId}>
            <Button type="light" icon={<LeftOutlined />} size="large">
              {languagesCms.BACK}
            </Button>
          </Link>
        </div>
      </div>

      <iframe
        id="print"
        src={'/surveysWithMedia2Print/' + surveyId + '/detail/' + id}
        style={{ display: 'none', width: '100%', height: '100%' }}
        title="Print"
      />

      <div className="form-wrap d-none">
        {!loading && (
          <Card title={id ? '' : ''} loading={loading}>
            <Form layout="horizontal" size={'large'} onFinish={save}>
              <Row direction="row">
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 10 }}
                  lg={{ span: 10 }}
                  xl={{ span: 6 }}
                >
                  <Image width={200} src={data.attendee_id.avatar.url}>
                    {' '}
                  </Image>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 14 }}
                  lg={{ span: 14 }}
                  xl={{ span: 18 }}
                >
                  <Col xs={{ span: 24 }}>
                    <Typography.Title
                      style={{ padding: 0, margin: 0 }}
                      level={2}
                    >
                      {[data.attendee_id.name, data.attendee_id.lastname]
                        .filter((x) => x)
                        .join(' ')}
                    </Typography.Title>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      Email : {data.attendee_id.email}
                    </Typography.Text>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      Telefon : {data.attendee_id.phone}
                    </Typography.Text>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      TC : {data.attendee_id.tc}
                    </Typography.Text>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      Doğum Tarihi : {data.attendee_id.birthdayString}
                    </Typography.Text>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      Firma : {data.attendee_id.company}
                    </Typography.Text>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      Departman : {data.attendee_id.department}
                    </Typography.Text>
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <Typography.Text>
                      Pozisyon : {data.attendee_id.position}
                    </Typography.Text>
                  </Col>
                </Col>
              </Row>
              <hr />

              <Row direction="row">
                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                  <Typography.Title style={{ textAlign: 'center' }} level={2}>
                    {languagesCms.ANSWERS}
                  </Typography.Title>
                </Col>
              </Row>
              <hr />
              {data.questions.map((item, index) => {
                if (item.type === 'Free') {
                  return (
                    <Row direction="row">
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Title level={4}>
                          {index + 1}. {item.name}
                        </Typography.Title>
                      </Col>
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Text level={2}>
                          {item.other}
                        </Typography.Text>
                      </Col>
                    </Row>
                  );
                } else if (item.type === 'Date' || item.type === 'DateRange') {
                  return (
                    <Row
                      style={{ width: '100%', maxWidth: '250px' }}
                      direction="row"
                    >
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Title level={4}>
                          {index + 1}. {item.name}
                        </Typography.Title>
                      </Col>
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <DatePicker
                          disabled
                          size="large"
                          format={
                            item.clockOption
                              ? 'DD-MM-YYYY HH:mm:ss'
                              : 'DD-MM-YYYY'
                          }
                          defaultValue={moment(
                            item.type === 'Date'
                              ? item.dateInput
                              : item.dateRangeInputStart,
                          )}
                          style={{ width: 250, marginLeft: 5 }}
                          showTime={item.clockOption}
                        />
                        {item.type === 'DateRange' && (
                          <DatePicker
                            disabled
                            size="large"
                            format={
                              item.clockOption
                                ? 'DD-MM-YYYY HH:mm:ss'
                                : 'DD-MM-YYYY'
                            }
                            defaultValue={moment(item.dateRangeInputEnd)}
                            style={{ width: 250, marginLeft: 5 }}
                            showTime={item.clockOption}
                          />
                        )}
                      </Col>
                    </Row>
                  );
                } else if (item.type === 'TextToImage') {
                  return (
                    <Row key={index} direction="row">
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Title level={4}>
                          {index + 1}. {item.name}
                        </Typography.Title>
                      </Col>
                      {item.choices.map((itemC, indexC) => {
                        return (
                          <Col
                            key={indexC}
                            xs={{ span: 24 }}
                            md={{ span: 10 }}
                            lg={{ span: 8 }}
                            xl={{ span: 6 }}
                          >
                            <Col
                              style={{
                                float: 'left',
                                position: 'relative',
                                right: '1.5rem',
                              }}
                            >
                              {itemC.is_selected === true ? (
                                <span>
                                  <CheckCircleOutlined
                                    style={{
                                      color: '#a0d911',
                                      fontSize: '2rem',
                                    }}
                                  />
                                </span>
                              ) : (
                                <span>
                                  <CloseCircleOutlined
                                    style={{ color: 'red', fontSize: '2rem' }}
                                  />
                                </span>
                              )}
                            </Col>
                            <Col>
                              <Image
                                width={200}
                                style={{ marginRight: 5, marginBottom: 10 }}
                                src={itemC.media.url}
                              >
                                {' '}
                              </Image>
                            </Col>
                          </Col>
                        );
                      })}
                    </Row>
                  );
                } else if (item.type === 'Media') {
                  return (
                    <Row direction="row">
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Title level={4}>
                          {index + 1}. {item.name}
                        </Typography.Title>
                      </Col>
                      {item.choices.map((itemC, indexC) => {
                        if (
                          itemC.media.url !== '' &&
                          itemC.media.type === 'image'
                        ) {
                          return (
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 10 }}
                              lg={{ span: 8 }}
                              xl={{ span: 6 }}
                            >
                              <Image
                                width={200}
                                style={{ marginRight: 5, marginBottom: 10 }}
                                src={itemC.media.url}
                              >
                                {' '}
                              </Image>
                            </Col>
                          );
                        } else if (
                          itemC.media.url !== '' &&
                          itemC.media.type === 'video'
                        ) {
                          return (
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 10 }}
                              lg={{ span: 8 }}
                              xl={{ span: 6 }}
                            >
                              <video
                                display="flex"
                                width="200"
                                height="200"
                                controls
                              >
                                <source
                                  src={itemC.media.url}
                                  type="video/mp4"
                                />
                              </video>
                            </Col>
                          );
                        } else if (
                          itemC.media.url !== '' &&
                          itemC.media.type === 'document'
                        ) {
                          return (
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 10 }}
                              lg={{ span: 8 }}
                              xl={{ span: 6 }}
                            >
                              <a href={itemC.media.url} target="/blank">
                                <Image
                                  width={200}
                                  className="login-wrap"
                                  style={{ marginRight: 5, marginBottom: 10 }}
                                  preview={false}
                                  background-color="blue"
                                  src={pdfIcon}
                                />
                              </a>
                            </Col>
                          );
                        } else {
                          return (
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 10 }}
                              lg={{ span: 8 }}
                              xl={{ span: 6 }}
                            >
                              <Image
                                width={200}
                                height={200}
                                src="error"
                                fallback="data:image/png;base64,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"
                              />
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  );
                } else if (item.type === 'Single') {
                  return (
                    <Row direction="row">
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Title level={4}>
                          {index + 1}. {item.name}
                        </Typography.Title>
                      </Col>
                      {item.choices.map((itemC, indexC) => {
                        if (
                          itemC.is_selected === true &&
                          itemC.is_media === true
                        ) {
                          if (
                            itemC.media.url !== '' &&
                            itemC.media.type === 'image'
                          ) {
                            return (
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Radio.Group
                                    name="radiogroup"
                                    defaultValue={indexC}
                                  >
                                    <Radio value={indexC}>{itemC.name} </Radio>
                                  </Radio.Group>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 6 }}
                                >
                                  <Image
                                    width={180}
                                    style={{ marginRight: 5, marginBottom: 10 }}
                                    src={itemC.media.url}
                                  >
                                    {' '}
                                  </Image>
                                </Col>
                              </Row>
                            );
                          } else if (
                            itemC.media.url !== '' &&
                            itemC.media.type === 'video'
                          ) {
                            return (
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Radio.Group
                                    name="radiogroup"
                                    defaultValue={indexC}
                                  >
                                    <Radio value={indexC}>{itemC.name} </Radio>
                                  </Radio.Group>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 6 }}
                                >
                                  <video
                                    display="flex"
                                    width="200"
                                    height="200"
                                    controls
                                  >
                                    <source
                                      src={itemC.media.url}
                                      type="video/mp4"
                                    />
                                  </video>
                                </Col>
                              </Row>
                            );
                          } else if (
                            itemC.media.url !== '' &&
                            itemC.media.type === 'document'
                          ) {
                            return (
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Radio.Group
                                    name="radiogroup"
                                    defaultValue={indexC}
                                  >
                                    <Radio value={indexC}>{itemC.name} </Radio>
                                  </Radio.Group>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 6 }}
                                >
                                  <a href={itemC.media.url} target="/blank">
                                    <Image
                                      width={200}
                                      className="login-wrap"
                                      style={{
                                        marginRight: 5,
                                        marginBottom: 10,
                                      }}
                                      preview={false}
                                      background-color="blue"
                                      src={pdfIcon}
                                    />
                                  </a>
                                </Col>
                              </Row>
                            );
                          } else {
                            return (
                              <Col
                                xs={{ span: 24 }}
                                md={{ span: 10 }}
                                lg={{ span: 8 }}
                                xl={{ span: 6 }}
                              >
                                <Image
                                  width={200}
                                  height={200}
                                  src="error"
                                  fallback="data:image/png;base64,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"
                                />
                              </Col>
                            );
                          }
                        } else if (
                          itemC.is_selected === true &&
                          itemC.is_other === true
                        ) {
                          return (
                            <Row>
                              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                <Radio.Group
                                  name="radiogroup"
                                  defaultValue={indexC}
                                >
                                  <Radio value={indexC}>{itemC.name} </Radio>
                                </Radio.Group>
                              </Col>
                              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                <Paragraph>
                                  <pre>{itemC.other}</pre>
                                </Paragraph>
                              </Col>
                            </Row>
                          );
                        } else if (
                          itemC.is_selected === true &&
                          itemC.is_media === false
                        ) {
                          return (
                            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                              <Radio.Group
                                name="radiogroup"
                                defaultValue={indexC}
                              >
                                <Radio value={indexC}>{itemC.name} </Radio>
                              </Radio.Group>
                            </Col>
                          );
                        } else {
                          return (
                            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                              <Radio.Group
                                name="radiogroup"
                                defaultValue={100000000000}
                              >
                                <Radio value={indexC} disabled>
                                  {itemC.name}
                                </Radio>
                              </Radio.Group>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  );
                } else if (item.type === 'Multiple') {
                  return (
                    <Row direction="row">
                      <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <Typography.Title level={4}>
                          {index + 1}. {item.name}
                        </Typography.Title>
                      </Col>
                      {item.choices.map((itemC, indexC) => {
                        if (
                          itemC.is_selected === true &&
                          itemC.is_media === true
                        ) {
                          if (
                            itemC.media.url !== '' &&
                            itemC.media.type === 'image'
                          ) {
                            return (
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Checkbox defaultChecked disabled>
                                    {itemC.name}{' '}
                                  </Checkbox>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 6 }}
                                >
                                  <Image
                                    width={180}
                                    style={{ marginRight: 5, marginBottom: 10 }}
                                    src={itemC.media.url}
                                  >
                                    {' '}
                                  </Image>
                                </Col>
                              </Row>
                            );
                          } else if (
                            itemC.media.url !== '' &&
                            itemC.media.type === 'video'
                          ) {
                            return (
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Checkbox defaultChecked disabled>
                                    {itemC.name}{' '}
                                  </Checkbox>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 6 }}
                                >
                                  <video
                                    display="flex"
                                    width="200"
                                    height="200"
                                    controls
                                  >
                                    <source
                                      src={itemC.media.url}
                                      type="video/mp4"
                                    />
                                  </video>
                                </Col>
                              </Row>
                            );
                          } else if (
                            itemC.media.url !== '' &&
                            itemC.media.type === 'document'
                          ) {
                            return (
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                  <Checkbox defaultChecked disabled>
                                    {itemC.name}{' '}
                                  </Checkbox>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 10 }}
                                  lg={{ span: 8 }}
                                  xl={{ span: 6 }}
                                >
                                  <a href={itemC.media.url} target="/blank">
                                    <Image
                                      width={200}
                                      className="login-wrap"
                                      style={{
                                        marginRight: 5,
                                        marginBottom: 10,
                                      }}
                                      preview={false}
                                      background-color="blue"
                                      src={pdfIcon}
                                    />
                                  </a>
                                </Col>
                              </Row>
                            );
                          } else {
                            return (
                              <Col
                                xs={{ span: 24 }}
                                md={{ span: 10 }}
                                lg={{ span: 8 }}
                                xl={{ span: 6 }}
                              >
                                <Image
                                  width={200}
                                  height={200}
                                  src="error"
                                  fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                                />
                              </Col>
                            );
                          }
                        } else if (
                          itemC.is_selected === true &&
                          itemC.is_other === true
                        ) {
                          return (
                            <Row>
                              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                <Checkbox defaultChecked disabled>
                                  {itemC.name}{' '}
                                </Checkbox>
                              </Col>
                              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                                <Paragraph>
                                  <pre>{itemC.other}</pre>
                                </Paragraph>
                              </Col>
                            </Row>
                          );
                        }
                        if (
                          itemC.is_selected === true &&
                          itemC.is_media === false
                        ) {
                          return (
                            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                              <Checkbox defaultChecked disabled>
                                {itemC.name}{' '}
                              </Checkbox>
                            </Col>
                          );
                        } else {
                          return (
                            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                              <Checkbox defaultChecked={false} disabled>
                                {itemC.name}
                              </Checkbox>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  );
                } else {
                  return '';
                }
              })}
              <hr />
              <Row direction="row">
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 20 }}
                >
                  <Col xs={{ span: 24 }}>
                    <Typography.Title style={{ textAlign: 'center' }} level={5}>
                      {languagesCms.FIRST_ANSWER_DATE}:{' '}
                      {moment(data.created).format('DD-MM-YYYY HH:mm')}
                    </Typography.Title>
                  </Col>
                </Col>
              </Row>
              <hr />
            </Form>
          </Card>
        )}
      </div>
    </div>
  );
};

export default SurveysWithMedia2AnswersDetail;
